import { useSyncExternalStore } from "react";
const ANON = "anon";
export function createLearning({ storageKey }) {
    let user = ANON;
    let state = { done: {} };
    const listeners = new Set();
    const completion = new Set();
    const load = (u) => {
        try {
            const raw = localStorage.getItem(`${storageKey}:${u}`);
            if (raw) {
                const s = JSON.parse(raw);
                if (s && typeof s.done === "object" && s.done)
                    return s;
            }
        }
        catch {
            // storage unavailable or corrupt: start fresh
        }
        return { done: {} };
    };
    const save = () => {
        if (user === ANON)
            return; // never persist before we know who is signed in
        try {
            localStorage.setItem(`${storageKey}:${user}`, JSON.stringify(state));
        }
        catch {
            // quota / private mode: progress is kept for this session only
        }
    };
    const emit = () => listeners.forEach((l) => l());
    return {
        setUser(sub) {
            if (!sub || sub === user)
                return;
            const early = state.done;
            user = sub;
            state = { done: { ...early, ...load(sub).done } };
            save();
            emit();
        },
        get userKnown() {
            return user !== ANON;
        },
        track(e) {
            if (state.done[e])
                return;
            state = { done: { ...state.done, [e]: new Date().toISOString() } };
            save();
            emit();
            completion.forEach((c) => c(e));
        },
        has: (e) => !!state.done[e],
        reset() {
            state = { done: {} };
            save();
            emit();
        },
        subscribe(l) {
            listeners.add(l);
            return () => {
                listeners.delete(l);
            };
        },
        onComplete(c) {
            completion.add(c);
            return () => {
                completion.delete(c);
            };
        },
        snapshot: () => state,
    };
}
/** Current learning state; re-renders when an event is tracked. */
export function useLearning(store) {
    return useSyncExternalStore(store.subscribe, store.snapshot, store.snapshot);
}
/** Tasks a user sees: admin-only tasks only for admins. */
export const visibleTasks = (tasks, admin) => tasks.filter((t) => admin || !t.adminOnly);
/** Progress over the given tasks. */
export function learningProgress(state, tasks) {
    const done = tasks.filter((t) => state.done[t.event]).length;
    return { done, total: tasks.length, ratio: tasks.length ? done / tasks.length : 0 };
}
